// extracted by mini-css-extract-plugin
module.exports = {"Doughnut":"DoughnutChart_Doughnut__PlWf4","Loader":"DoughnutChart_Loader__3Xtvp"};